export const getYearlyPriceForAllMonths = (priceForTenMonths) => {
    const pricePerMonth = priceForTenMonths / 10;
    const pricePerFullYear = pricePerMonth * 12;

    return pricePerFullYear;
};
